import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-thumbnail.css';
import 'lightgallery/css/lg-zoom.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
// import '../eventDetails/EventDetailPage.css';
import eventImg1 from '../../../assets/images/events/eventdetail-1.png';
import eventImg2 from '../../../assets/images/events/eventdetail-2.png';
import eventImg3 from '../../../assets/images/events/eventdetail-3.png';
import eventImg4 from '../../../assets/images/events/mauk-2019.jpg';
import eventBannerBg from '../../../assets/images/events/eventdetail-blur.png';
import calendarIcon from '../../../assets/images/icons/white-calendar.svg';
import locationIcon from '../../../assets/images/icons/white-location.svg';
import photoGalleryIcon from '../../../assets/images/icons/photo-gallery.svg';
import hourglass from '../../../assets/images/icons/hourglass-icon.svg';
import profileIcon from '../../../assets/images/icons/person-icon.svg';  
import pawicon from '../../../assets/images/icons/paw-icon.svg';
import pinkLocation from '../../../assets/images/icons/pink-location-icon.svg';
import eventBanner1 from '../../../assets/images/events/banner-ponnonam.png';
import sponsor1 from '../../../assets/images/sponsors/chai-kadai.png';
import sponsor2 from '../../../assets/images/sponsors/gsl.jpg';
import sponsor3 from '../../../assets/images/sponsors/law-and-lawyers.jpg';
import sponsor4 from '../../../assets/images/sponsors/life-line.jpg';
import sponsor5 from '../../../assets/images/sponsors/newham-london.jpg';
import sponsor6 from '../../../assets/images/sponsors/swayam.jpg';
import './SponsorsSection.css';
import { getEventById } from '../../../services/apiService';
import NotFound404 from '../../../components/404Page/NotFound404';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlayCircle } from '@fortawesome/free-solid-svg-icons';
import { isEventOver } from '../../../utils/urlUtils';
import { combineDateAndTime, formatEventDateTimeFromAPI } from '../../../utils/timeUtils';

// Utility function to safely format dates
const formatEventDateTime = (datetime) => {
  try {
    const eventDate = new Date(datetime);
    if (isNaN(eventDate.getTime())) {
      return 'Date not available';
    }
    
    // Format date
    const dateStr = eventDate.toLocaleDateString();
    
    // Format time in 12-hour format with AM/PM
    const timeStr = eventDate.toLocaleTimeString('en-US', { 
      hour: 'numeric', 
      minute: '2-digit',
      hour12: true 
    });
    
    return `${dateStr} • ${timeStr}`;
  } catch (error) {
    return 'Date not available';
  }
};

// Utility to format description with paragraphs and line breaks
const formatDescription = (desc) => {
  if (!desc) return null;
  // Split by double newlines for paragraphs
  return desc.split(/\n\n+/).map((para, idx) => (
    <p key={idx} style={{ whiteSpace: 'pre-line', marginBottom: '1.2em' }}>
      {para.split('\n').map((line, i, arr) =>
        i < arr.length - 1 ? <React.Fragment key={i}>{line}<br /></React.Fragment> : line
      )}
    </p>
  ));
};

const Ponnonam2025 = () => {
  const [eventData, setEventData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const galleryRef = useRef(null);

  const openGallery = () => {
    galleryRef.current?.openGallery(0);
  };

  useEffect(() => {
    const fetchEvent = async () => {
      try {
        setIsLoading(true);
        setError(null);
        
        // Use a specific event ID for Ponnonam 2025
        // You can replace this with the actual event ID from your API
        const eventId = "683576c5576c66d3d2841e04"; // or the actual ID from your database
        const response = await getEventById(eventId);
        
        console.log("API Response:", response);
        
        if (response) {
          const data = response;
          
          // Handle datetime properly using utility function
          const datetime = combineDateAndTime(data.date, data.time);

          const transformed = {
            id: data._id,
            title: data.title,
            description: data.description,
            datetime: datetime,
            date: data.date, // Preserve original date
            time: data.time, // Preserve original time
            venue: {
              name: data.venue,
              address: data.address,
              map_url: data.map,
            },
            images: [
              eventBanner1,
            //   eventImg2,
              eventImg4,
              eventImg3,
            ],
            galleryCount: 3,
            duration: data.duration,
            ageLimit:
              !data.ageGroup ||
              data.ageGroup === "0" ||
              data.ageGroup === 0 ||
              data.ageGroup === "N/A"
                ? "N/A"
                : data.ageGroup,
            petFriendly: data.pet, 
            layoutImage: null, 
            seatingPlan: data.seatingPlan
          };

          setEventData(transformed);
        } else {
          console.error("API returned error:", response);
          setError("Event not found");
        }
      } catch (error) {
        console.error("API fetch failed:", error);
        setError("Failed to load event");
      } finally {
        setIsLoading(false);
      }
    };

    fetchEvent();
  }, []);

  // Show loading state while fetching data
  if (isLoading) {
    return (
      <div className="container py-5">
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
          <div className="text-center">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-3">Loading Ponnonam 2025 details...</p>
          </div>
        </div>
      </div>
    );
  }

  // Show error state
  if (error || !eventData) {
    return <NotFound404 />;
  }

  const {
    title,
    description,
    datetime,
    venue,
    images,
    galleryCount,
    duration,
    ageLimit,
    petFriendly,
    ticketPrices,
    layoutImage,
    seatingPlan
  } = eventData;

  const eventSummary = {
    title,
    datetime,
    venue,
    image: images[0],
    seatingPlan: seatingPlan
  };
  sessionStorage.setItem("selectedEvent", JSON.stringify(eventSummary));

  // Prepare gallery items: main image, right-top image, and video
  const galleryItems = [
    { src: images[0], thumb: images[0], type: 'image' },
    { src: images[1], thumb: images[1], type: 'image' },
    { src: 'https://www.youtube.com/embed/9-btXY2TUmY',
      thumb: 'https://img.youtube.com/vi/9-btXY2TUmY/hqdefault.jpg',
      poster: 'https://img.youtube.com/vi/9-btXY2TUmY/hqdefault.jpg',
      iframe: true,
      type: 'video',
      youtube: true
    }
  ];

  return (
    <>
      <section className="eventdetail-banner py-5 position-relative"  
        style={{
          backgroundImage: `
            url(${eventBannerBg}), 
            url(${images[0]})
          `,
          backgroundSize: 'cover, cover',
          backgroundPosition: 'center, center',
          backgroundRepeat: 'no-repeat, no-repeat',
        }}>
        <div className="blur-overlay"></div>
        <div className="container-fluid container-xxl px-md-5 py-4">
          {/* Header Section */}
          <div className="row gy-5">
            <div className="col-md-7">
              <div className="row">
                <div className="col-7">
                  <img
                    src={images[0]}
                    className="img-fluid rounded mb-2 w-100 h-100"
                    alt="Main Banner"
                    onClick={openGallery}
                    style={{ cursor: 'pointer' }}
                  />
                </div>
                <div className="col-5">
                  <div className="d-flex gap-3 flex-column">
                    <div className="position-relative">
                      <img
                        src={images[1]}
                        className="img-thumbnail w-100"
                        alt="Gallery 0"
                        onClick={openGallery}
                        style={{ cursor: 'pointer' }}
                      />
                    </div>
                    <div className="position-relative">
                      {/* Show YouTube thumbnail with play icon overlay */}
                      <img
                        src="https://img.youtube.com/vi/9-btXY2TUmY/hqdefault.jpg"
                        alt="Ponnonam 2025 Promo Video"
                        className="img-thumbnail w-100"
                        onClick={openGallery}
                        style={{ cursor: 'pointer', objectFit: 'cover', minHeight: '120px' }}
                      />
                      <FontAwesomeIcon
                        icon={faPlayCircle}
                        style={{
                          position: 'absolute',
                          top: '50%',
                          left: '50%',
                          transform: 'translate(-50%, -50%)',
                          fontSize: '3rem',
                          color: '#fff',
                          textShadow: '0 2px 8px rgba(0,0,0,0.5)',
                          pointerEvents: 'none'
                        }}
                      />
                      <div
                        className="position-absolute bottom-0 end-0 p-2 bg-white rounded text-center view-gallery"
                        style={{
                          boxShadow: '0 0 10px rgba(0,0,0,0.3)',
                          zIndex: 1,
                          marginBottom: '10px',
                          marginRight: '10px',
                          cursor: 'pointer'
                        }}
                        onClick={openGallery}
                      >
                        <span><img src={photoGalleryIcon} alt="photo-gallery" className="img-fluid pe-2" /> View {galleryCount} more...</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4 ps-md-5 d-flex flex-column justify-content-between event-details-rhs">
              <div> 
                <h1 className='text-white event-title'>{title}</h1>
                <p className="text-white event-desc">{description}</p>
                <p className='text-white d-flex align-items-center'>
                  <img src={calendarIcon} alt="calendar-icon" className="img-fluid pe-2"/> 
                  {formatEventDateTimeFromAPI(eventData.date, eventData.time)}
                </p>
                <p className='text-white d-flex align-items-center'>
                  <img src={locationIcon} alt="location-icon" className="img-fluid pe-2"/> {venue.name}
                </p>
              </div>
              <div className=''>
                {isEventOver(datetime) ? (
                  <div className="text-center">
                    <button className="btn btn-secondary btn-lg w-100" disabled>
                      Event Ended
                    </button>
                    <p className="text-white-50 mt-2 mb-0 small">This event has already taken place</p>
                  </div>
                ) : (
                  <Link
                    to={`/view-seats/ponnonam-2025`}
                    state={{
                      title,
                      datetime,
                      venue,
                      image: images[0], 
                      seatingPlan: seatingPlan
                    }}
                    className="btn btn-primary btn-lg w-100"
                  >
                    View Bookings
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="container-fluid container-xxl px-md-5 mt-5 about-event">
        {/* About Event */}
        <div className="row pb-5">
          <div className="col-md-7 pe-md-5">
            <div className="mb-5 pe-md-5">
              <h4 className="section-heading">About the Event</h4>
              {formatDescription(description)}
            </div>

            {/* Guide & Layout */}
            <div className="row event-guide-layout pe-md-5">
              {/* Guide */}
              <div className="col-md-12 mb-4 pe-md-5">
                <h4 className="section-heading">Event Guide</h4>
                <div className="d-flex gap-3 pt-3 justify-content-center">
                  <div className="p-3 border rounded flex-fill d-flex align-items-center justify-content-center">
                    <img src={hourglass} alt="hourglass" className="img-fluid pe-3" />
                    <div>
                      <p className='mb-0'>Duration</p>
                      <p className="fw-bold mb-0">{duration}</p>
                    </div>
                  </div>
                  <div className="p-3 border rounded flex-fill d-flex align-items-center justify-content-center">
                    <img src={profileIcon} alt="profile" className="img-fluid pe-3" />
                    <div>
                      <p className='mb-0'>Age Limit</p>
                      <p className="fw-bold mb-0">{ageLimit}</p>
                    </div>
                  </div>
                  <div className="p-3 border rounded flex-fill d-flex align-items-center justify-content-center">
                    <img src={pawicon} alt="paw" className="img-fluid pe-3" />
                    <div>
                      <p className='mb-0'>Pet Friendly</p>
                      <p className="fw-bold mb-0">{petFriendly === "true" ? "Yes" : "No"}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-5 ps-md-5">
            <div className="mt-4 event-venue">
              <h4 className="section-heading mb-3">Venue</h4>

              <div className="d-flex justify-content-between align-items-center flex-wrap">
                <div className="d-flex align-items- mb-3">
                  <img src={pinkLocation} alt="location-icon" className="img-fluid pe-3 mt-1" />
                  <div>
                    <p className="venue-name mb-1">{venue.name}</p>
                    <p className="venue-address mb-0">{venue.address}</p>
                   
                  </div>
                </div>

                <a
                  href={venue.map_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-secondary text-pink border-pink"
                >
                  View Map
                </a>
              </div>
              <div className='mt-5' style={{ borderRadius: '8px', overflow: 'hidden' }}>
                      <iframe
                        title="Venue Map"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2481.4542345025543!2d0.09116149999999999!3d51.5415693!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47d8a675e4173065%3A0x55df30e6eadf83cb!2sEastbury%20Community%20School!5e0!3m2!1sen!2sin!4v1753258091028!5m2!1sen!2sin"
                        width="100%"
                        height="250"
                        style={{ border: 0, boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                      ></iframe>
                    </div>

                    <div className="mt-4 transport-info p-4 border rounded" style={{ backgroundColor: '#f9f9fc' }}>
  <h5 className="mb-3 text-primary fw-bold">Getting Here</h5>

  <div className="mb-3">
    <h6 className="text-dark fw-semibold">🚌 Bus</h6>
    <p className="mb-2">
      The nearest bus stop is <strong>Hulse Avenue / Barking Park</strong>, served by multiple routes.
    </p>
    <p className="mb-2">
      <strong>Route 287</strong> also stops near the school at <strong>Renwick Road K</strong> and <strong>Castle Green Recreation Ground L</strong>.
    </p>
    <p className="mb-0">
      Other routes: <span className="text-muted">5, 62, 169, 238, 366, 368, 687, EL1, EL2, EL3, N15, SL2</span>
    </p>
  </div>

  <div className="mb-3">
    <h6 className="text-dark fw-semibold">🚇 Underground</h6>
    <p className="mb-2">
      The closest station is <strong>Barking</strong>, served by the <strong>District</strong> and <strong>Hammersmith & City</strong> lines.
    </p>
    <p className="mb-0">
      These lines provide quick connections to various parts of London.
    </p>
  </div>

  <div>
    <h6 className="text-dark fw-semibold">🚆 Rail</h6>
    <p className="mb-2">
      <strong>Barking station</strong> also offers <strong>c2c</strong> and <strong>London Overground</strong> services.
    </p>
    <p className="mb-0">
      Convenient links both within London and to destinations beyond the city.
    </p>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>

      {/* LightGallery - Hidden until triggered */}
      <LightGallery
        onInit={(ref) => (galleryRef.current = ref.instance)}
        dynamic
        dynamicEl={galleryItems}
        plugins={[lgThumbnail, lgZoom]}
        mode="lg-fade"
      />

      {/* Sponsors Section */}
      <section className="sponsors-section container-fluid container-xxl px-md-5 mb-5">
        <div className="sponsors-heading text-center mb-4">
          <h3 className="section-heading mb-2">Featured Sponsors</h3>
          <p className="">We thank our generous sponsors for supporting Ponnonam 2025</p>
        </div>
        <div className="sponsors-logos row justify-content-center align-items-center g-4">
          {[sponsor1, sponsor2, sponsor3, sponsor4, sponsor5, sponsor6].map((img, idx) => (
            <div className="col-6 col-md-2 d-flex justify-content-center" key={idx}>
              <div className="sponsor-logo-card fade-in">
                <img src={img} alt={`Sponsor ${idx+1}`} className="img-fluid sponsor-logo" />
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default Ponnonam2025; 